import React from "react";

const None = () => {
  return <span>This request does not have a body</span>;
};
export default None;
